import { get, post, del } from "../AxiosConfig";

const URI = "/sysadmin";

const getCompaniesStats = () => {
  return get(`${URI}/companies-stats`);
};

const getCasponetConfig = (companyId) => {
  return get(`${URI}/casponet-config?companyId=${companyId}`);
};

const saveCasponetConfig = (payload) => {
  return post(`${URI}/casponet-config`, payload);
};

const getCompanyParameters = (companyId) => {
  return get(`${URI}/company-parameters?companyId=${companyId}`);
};

const saveCompanyParameters = (payload) => {
  return post(`${URI}/company-parameters`, payload);
};

const getMessagesToCompany = (companyId) => {
  return get(`${URI}/messages-to-company?companyId=${companyId}`);
};

const saveMessagesToCompany = (payload) => {
  return post(`${URI}/messages-to-company`, payload);
};

const getBillingReport = (payload) => {
  return get(`${URI}/billing-report?companyId=${payload.companyId}&from=${payload.from}&to=${payload.to}`);
};

const getDeletedCompanies = () => {
  return get(`${URI}/deleted-companies`);
};

const restoreCompany = (payload) => {
  return post(`${URI}/restore-company`, payload);
};

const getKindOfDay = () => get(`${URI}/kindofday`);

const getCalendarMonth = (year, month) =>
  get(`${URI}/calendar?year=${year}&month=${month}`);

const upsertCalendarDay = (payload) => post(`${URI}/calendar`, payload);

const deleteCalendarDay = (id) => del(`${URI}/calendar/${id}`);

const SysAdminService = {
  getCompaniesStats,
  getCasponetConfig,
  saveCasponetConfig,
  getCompanyParameters,
  saveCompanyParameters,
  getMessagesToCompany,
  saveMessagesToCompany,
  getBillingReport,
  getDeletedCompanies,
  restoreCompany,
  getKindOfDay,
  getCalendarMonth,
  upsertCalendarDay,
  deleteCalendarDay,
};

export default SysAdminService;
